// extracted by mini-css-extract-plugin
export default {"imgdiv":"_633331852d b94679f47b","img":"d5fd107fd5 b27c083c75"};